import { useRef } from 'react';
export function useProgressAnimation(percent, isSVG) {
  var prevPercentRef = useRef(0);
  var percentDiff = Math.abs(percent - prevPercentRef.current);
  var isEnter = percent > 0 && prevPercentRef.current <= 0;
  var isLeave = percent <= 0 && prevPercentRef.current > 0;
  prevPercentRef.current = percent;
  var widthDuration = 100;
  var dashDuration = Math.min(percentDiff * 4 + 100, 400);
  var dashDelay = isEnter ? widthDuration : 0;
  var widthDelay = isLeave ? dashDuration : 0;

  if (!isSVG) {
    return {
      transition: ["width ".concat(dashDuration, "ms ease-out"), "height ".concat(dashDuration, "ms ease-out")].join(', ')
    };
  }

  return {
    transition: ["stroke ".concat(dashDuration, "ms ease-out ").concat(dashDelay, "ms"), "stroke-dashoffset ".concat(dashDuration, "ms ease-out ").concat(dashDelay, "ms"), "stroke-dasharray ".concat(dashDuration, "ms ease-out ").concat(dashDelay, "ms"), "stroke-width ".concat(widthDuration, "ms ease-out ").concat(widthDelay, "ms")].join(', ')
  };
}